import { render, staticRenderFns } from "./CourseGift.vue?vue&type=template&id=8113df48&scoped=true&"
import script from "./CourseGift.vue?vue&type=script&lang=js&"
export * from "./CourseGift.vue?vue&type=script&lang=js&"
import style0 from "./CourseGift.vue?vue&type=style&index=0&id=8113df48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8113df48",
  null
  
)

export default component.exports